export default "__VITE_ASSET__71946f04__"